module.exports = __webpack_public_path__ + "img/appStore.f07ac7e2.png";